import DromoUploader from "dromo-uploader-react"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useRef } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { createDromoImport } from "src/api/DromoImports"

import { useToast } from "src/hooks/use_toast"

import { ImportHistoryContext } from "../ImportHistoryContext"

const DROMO_LICENSE_KEY = window.DockwaConfig?.DROMO_FRONTEND_LICENSE_KEY || ""

const DromoImporter = ({
  importType,
  fields,
  columnHooks = [],
  rowHooks = [],
  stepHooks = [],
  onClose,
}) => {
  const { marinaSlug } = useMarina()
  const { currentUserId } = useContext(ImportHistoryContext)
  const showToast = useToast()

  const importCompleteRef = useRef(false)

  useEffect(() => {
    window.onbeforeunload = () => {
      if (!importCompleteRef.current) return true
    }
    return () => {
      window.onbeforeunload = undefined
    }
  }, [])

  const settings = {
    importIdentifier: importType,
    developmentMode: process.env.NODE_ENV === "development",
    backendSyncMode: "FULL_DATA",
    invalidDataBehavior: "BLOCK_SUBMIT",
    allowEmptySubmit: false,
    templateDownloadFilename: `${importType}-import-template.csv`,
  }

  const user = {
    id: currentUserId,
    company_id: marinaSlug,
  }

  const handleResults = async (data, metadata) => {
    try {
      await createDromoImport({
        dromoId: metadata.id,
        importType,
        numRows: data.length,
      })

      showToast("Import started, processing will begin shortly", {
        type: "success",
      })
      importCompleteRef.current = true
      window.location.href = `/manage/${marinaSlug}/dromo_imports`
    } catch (error) {
      showToast(error.message || "Failed to start import processing", {
        type: "error",
      })
      onClose?.()
    }
  }

  return (
    <DromoUploader
      licenseKey={DROMO_LICENSE_KEY}
      fields={fields}
      settings={settings}
      user={user}
      onResults={handleResults}
      onCancel={onClose}
      open
      columnHooks={columnHooks}
      rowHooks={rowHooks}
      stepHooks={stepHooks}
    />
  )
}

DromoImporter.propTypes = {
  importType: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  columnHooks: PropTypes.array,
  rowHooks: PropTypes.array,
  stepHooks: PropTypes.array,
  onClose: PropTypes.func,
}

export default DromoImporter
